const passwordFormTemplate = [
    {
        title: 'Password',
        fields: [
            {
                label: 'Password',
                component: 'PasswordField',
                model: 'password',
                required: true,
                rules: 'required'
            },
            {
                label: 'Repeat password',
                component: 'PasswordField',
                model: 'passwordRepeat',
                required: true,
                rules: 'confirmed:@password'
            }
        ]
    }
];

export default passwordFormTemplate;
